import BaseMessageHandler from 'messages/BaseMessageHandler';
import { createAction } from 'helpers/redux';
import ACTIONS from 'constants/actionTypes';

export default class Settlement_CreateConfirmed extends BaseMessageHandler {
  validation = () => {
    const { dispatch, message } = this;
    const { payload } = message;

    dispatch(
      createAction({
        type: ACTIONS.SET_USER_ERROR,
        payload,
      })
    );
  };
}
